class ShopTheLookButtons extends HTMLElement {
    constructor() {
        super();

        this.stlButton = this.querySelector('#ShopTheLook');
        this.prButton = this.querySelector('#ProductRecommendations');
        this.tabs = document.querySelector('.shop-the-look-tabs');
        this.stlTabTitle = document.querySelector('.shop-the-look-tab');
        this.stlTabItem = document.querySelector('.shop-the-look-tab-item');
        this.prTabTitle = document.querySelector('.product-recommendations-tab');
        this.prTabItem = document.querySelector('.product-recommendations-tab-item');

        if (this.stlButton) {
            this.stlButton.addEventListener('click', () => {
                this.scrollToTab();
                if (this.tabs) {
                    this.prTabTitle.classList.remove('active');
                    this.prTabItem.classList.remove('active');

                    this.stlTabTitle.classList.add('active');
                    this.stlTabItem.classList.add('active');
                }
            })
        }
        if (this.prButton) {
            this.prButton.addEventListener('click', () => {
                this.scrollToTab();
                if (this.tabs) {
                    this.stlTabTitle.classList.remove('active');
                    this.stlTabItem.classList.remove('active');

                    this.prTabTitle.classList.add('active');
                    this.prTabItem.classList.add('active');
                }

            })
        }
    }

    scrollToTab() {
        const el = '.product-recommendations-shop-the-look';
        const yOffset = -30;
        const element = document.querySelector(el);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });

    }
}

customElements.define('shop-the-look-buttons', ShopTheLookButtons);
